export default __webpack_public_path__ + "static/media/scottish.76fba644.png";